import * as React from 'react'
const SvgComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 72 88"
    width="100%"
    height="100%"
    preserveAspectRatio="xMidYMid slice"
  >
    <mask
      id="a"
      width="94"
      height="88"
      x="-11"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{maskType: 'alpha'}}
    >
      <path fill="#D9D9D9" d="M-10.088 0h92.176v88h-92.176V0Z" />
    </mask>
    <g mask="url(#a)">
      <path fill="#ECF4FB" d="M-10.841-3.904h209.424V90.54H-10.841V-3.904Z" />
      <path
        fill="#D9F0E7"
        d="M40.341 42.816c-3.208-3.015-10.19-8.691-12.443-7.285-1.644 1.758-.47 12.057-1.409 14.318-.939 2.26-1.878 5.777-3.052 7.284-.94 1.206-5.478 10.13-8.217 14.317l3.052 1.758 11.27-11.051L43.627 48.09l-3.287-5.275ZM17.568 14.934l-6.104 9.796-16.2-2.762-4.226-4.27c1.409-1.089 4.226-4.07 4.226-7.285S1.525 4.05 4.655 2.878c.079.335 1.55 1.205 6.809 2.01 5.26.803 8.296 5.609 8.922 7.786l-2.818 2.26Z"
      />
      <path
        fill="#BFDAF9"
        d="M42.69 76.222c-1.481 1.981-.042 9.985.9 13.901.026.112.04.223.04.338 0 .832.694 1.466 1.462 1.335l2.11-.361c1.181-.203 1.894-1.523 1.543-2.746-.495-1.723-1.005-3.889-1.125-5.685-.188-2.814 2.583-5.694 3.992-6.782l5.761-5.927c.225-.232.496-.399.797-.485 6.67-1.915 20.066-4.522 22.085-5.896 2.582-1.758 3.522.753 6.809 2.763 2.453 1.5 5.097 6.177 4.995 8.77-.013.347-.181.656-.403.91a974.003 974.003 0 0 0-5.766 6.647c-1.55 1.808-2.14 5.049-2.305 7.475-.077 1.13.831 2.005 1.888 1.927l3.552-.262c.794-.059 1.468-.646 1.68-1.467l.82-3.152c1.095-3.768 3.756-11.303 5.634-11.303 2.348 0 5.635-5.777 8.217-10.55 2.583-4.772-3.756-8.791-7.513-9.796-3.756-1.005-12.208 1.005-14.79 1.005-2.583 0-26.296 5.777-29.583 8.791-2.858 2.62-8.922 8.038-10.8 10.55ZM-4.502 19.706c-3.005-.401-5.321-3.014-6.104-4.27l-2.817 22.607c1.174-1.34 3.71-4.12 4.46-4.522.94-.502.47-2.511.47-3.516s3.991-2.512 4.93-3.014c.94-.503 5.4 2.01 6.81 2.26 1.408.252 1.643 1.759 3.286.754s4.696 2.763 5.635 4.019c.939 1.256 11.504 4.772 13.617 9.294 2.113 4.52 0 11.303 0 12.81 0 1.507-3.991 11.805-5.635 13.312-1.643 1.508-4.226 9.043-5.4 12.81-.939 3.015-2.739 7.955-3.521 10.048h6.104c.313-2.093.939-6.681.939-8.29 0-2.008 2.583-5.525 2.583-8.54 0-2.41 5.321-9.21 7.982-12.307 1.487-4.27 4.79-13.464 6.104-16.076 1.644-3.265-2.817-8.791-7.278-10.55-3.568-1.406-6.026-4.27-6.808-5.525-2.896-2.345-9.486-7.134-12.679-7.536-3.99-.502-8.921-3.265-12.678-3.768Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M1.862 44.414c.082-.263.348-.405.594-.317l5.696 2.031c.99.353 1.521 1.501 1.183 2.557L.64 75.882c-.084.263-.351.403-.597.313a.512.512 0 0 1-.292-.638L8.447 48.36c.169-.528-.097-1.102-.592-1.279L2.16 45.05a.511.511 0 0 1-.297-.636Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13.989 56.416c.24.104.355.398.257.655a296.826 296.826 0 0 0-1.61 4.33 86.833 86.833 0 0 0-.682 1.943c-.087.26-.155.474-.2.633a3.457 3.457 0 0 0-.056.216c-.004.104-.03.2-.049.26-.024.08-.056.166-.092.254-.072.178-.173.393-.29.631a45.838 45.838 0 0 1-.896 1.688c-.45.819-.946 1.687-1.327 2.357-.189.331-.35.614-.464.818a1.853 1.853 0 0 1-.334.391c-.137.13-.314.285-.525.459-.421.347-.994.788-1.678 1.297a225.443 225.443 0 0 1-5.216 3.73 783.995 783.995 0 0 1-11.888 8.105.452.452 0 0 1-.647-.16.523.523 0 0 1 .15-.692 783.738 783.738 0 0 0 11.87-8.095 224.736 224.736 0 0 0 5.194-3.712c.68-.506 1.237-.936 1.64-1.27.203-.166.361-.304.475-.412.095-.09.136-.14.149-.155l.003-.003c.12-.215.286-.504.477-.84.38-.666.863-1.514 1.312-2.328.336-.61.647-1.191.873-1.648.114-.229.202-.42.26-.563.03-.072.049-.125.06-.16l.005-.017c.004-.08.02-.156.031-.205.016-.07.038-.152.064-.241.052-.18.125-.41.213-.675.177-.532.421-1.223.69-1.968.54-1.492 1.187-3.216 1.618-4.348.098-.257.372-.38.612-.275Zm-3.226 7.7Z"
        clipRule="evenodd"
      />
      <path
        fill="#FFEBB5"
        fillRule="evenodd"
        d="M48.91-15.401c.62.208.963.913.769 1.574-1.08 3.676-3.377 7.438-5.756 10.636a66.935 66.935 0 0 1-6.616 7.588c-.173.17-.356.313-.549.436l-18.06 11.594a1.22 1.22 0 0 0-.416.453l-7.068 13.235a3.76 3.76 0 0 1-.501.722l-3.845 4.342c-.062.07-.117.147-.162.23L-1.24 49.984a1.3 1.3 0 0 0-.107.26L-9.955 79.86c-.192.663-.85 1.033-1.47.827-.618-.206-.964-.91-.771-1.572l8.607-29.618a3.91 3.91 0 0 1 .321-.78l7.946-14.573c.136-.25.3-.482.485-.693l3.845-4.342c.065-.073.121-.154.167-.24l7.069-13.235c.3-.56.728-1.03 1.246-1.361L35.55 2.679c.068-.043.124-.088.175-.137a64.494 64.494 0 0 0 6.36-7.297c2.315-3.11 4.402-6.586 5.354-9.825.194-.662.853-1.03 1.472-.821Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M75.236 66.945c-.216-.294-.65-.382-1.169-.18l-1.557.604c.03.098.09.24.184.426.112.22.259.474.427.747.338.545.75 1.142 1.113 1.645.287.397.625.584.915.535.28-.047.512-.163.664-.357.146-.187.275-.518.218-1.126-.102-1.087-.454-1.83-.795-2.294Zm-3.61.767c.06.18.147.373.243.562.13.255.292.536.47.823.354.573.78 1.19 1.152 1.705.379.523 1.02 1.044 1.803.912.423-.07.895-.266 1.239-.704.35-.447.507-1.071.432-1.87-.12-1.279-.54-2.204-.99-2.816-.581-.79-1.536-.773-2.228-.504-2.758 1.072-7 2.717-7.493 2.893-.234.083-.476.276-.684.465a9.47 9.47 0 0 0-.689.715 22.04 22.04 0 0 0-1.197 1.5.526.526 0 0 0 .083.704c.204.17.5.131.658-.088.268-.367.704-.932 1.14-1.427.218-.247.43-.47.615-.64.2-.182.324-.26.371-.276a563.91 563.91 0 0 0 5.076-1.954Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M68.812 50.639a3.748 3.748 0 0 0-1.328.177l-13.209 4.262a3.9 3.9 0 0 0-1.272.696l-2.11 1.727a4.285 4.285 0 0 0-1.395 2.154l-1.323 4.67c-.43 1.518-1.426 2.781-2.753 3.491l-1.427.763c-.75.401-1.576.61-2.415.61H24.61v-1.507h16.97c.62 0 1.231-.154 1.785-.45l1.427-.764c.98-.525 1.717-1.458 2.035-2.58l1.323-4.67a5.797 5.797 0 0 1 1.887-2.914l2.11-1.727a5.28 5.28 0 0 1 1.721-.942l13.209-4.261a5.069 5.069 0 0 1 1.797-.24l15.184.716 23.252 2.303c1.55.154 2.963 1.015 3.876 2.364l3.699 5.465.213.38c.385.686.632 1.45.726 2.243l1.396 11.735c.069.58.249 1.138.528 1.64l8.424 15.18-1.211.77-8.425-15.18a6.05 6.05 0 0 1-.713-2.22l-1.396-11.735a4.48 4.48 0 0 0-.537-1.658l-.182-.324-3.663-5.412c-.675-.997-1.719-1.634-2.865-1.747l-23.218-2.3-15.15-.715Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m50.086 57.802 1.172-.836 8.902 14.286 5.378 7.004-1.088.957-5.423-7.062-8.94-14.349ZM68.73 32.704l-1.252-1.34.665-.71 1.251 1.34c.06.062.093.07.1.071.268.035.713.027 1.21.004l.414-.02a19.6 19.6 0 0 1 .919-.035c.259 0 .47.225.47.503 0 .277-.211.502-.47.502-.221 0-.516.015-.845.032l-.448.022c-.482.022-1.007.036-1.365-.01a1.102 1.102 0 0 1-.649-.359ZM85.42-5.412l-54 39.184-.527-.831 54-39.185.526.832Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M62.411 33.27 43.159 3.631l.771-.573 19.252 29.64-.771.572Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M76.028 14.18 47.384 34.275l-.515-.84L75.513 13.34l.515.84Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M76.498 15.687 69.924 5.64l.77-.577 6.573 10.048-.77.576Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillOpacity={0.6}
        fillRule="evenodd"
        d="M72.74 26.237 53.02-4.909l1.166-.845 19.722 31.146-1.166.845Z"
        clipRule="evenodd"
      />
      <path
        fill="#FFEBB5"
        fillRule="evenodd"
        d="M23.964 66.748c8.196-8.496 25.828-26.772 54.484-46.341l1.264 2.117C51.274 41.944 33.81 60.041 25.597 68.552a214.373 214.373 0 0 1-3.242 3.32c-3.069 3.03-7.777 7.437-11.921 11.21A348.65 348.65 0 0 1 4.9 88.03a94.024 94.024 0 0 1-1.953 1.662c-.505.415-.945.76-1.232.934a58.27 58.27 0 0 1-1.462.839c-.517.291-1.095.617-1.66.944-1.304.755-2.584 1.542-3.322 2.145l-1.423-1.998c.904-.738 2.34-1.61 3.627-2.356.641-.371 1.24-.707 1.75-.995.568-.32 1.03-.579 1.326-.76.124-.076.44-.313.966-.745a91.638 91.638 0 0 0 1.903-1.62 346.095 346.095 0 0 0 5.493-4.912c4.133-3.762 8.815-8.146 11.85-11.144.833-.822 1.898-1.926 3.202-3.277Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M47.034 54.733a109.682 109.682 0 0 1-2.649-5.157l.835-.46a108.737 108.737 0 0 0 2.622 5.104c.466.84.901 1.576 1.25 2.084.177.256.318.436.421.542a.56.56 0 0 0 .076.068c-.002-.001-.023-.013-.06-.021a.332.332 0 0 0-.18.014l.298.953a.598.598 0 0 1-.502-.06 1.34 1.34 0 0 1-.28-.227 5.237 5.237 0 0 1-.53-.675c-.376-.548-.83-1.317-1.3-2.165ZM86.247 73.19l-20.1 5.865a3.817 3.817 0 0 0-.952.422c-1.406.876-3.77 2.448-5.058 3.654-.306.287-.608.764-.89 1.394-.28.623-.525 1.36-.735 2.13a29.72 29.72 0 0 0-.8 4.196l-.933-.12a30.77 30.77 0 0 1 .831-4.357c.219-.802.48-1.594.79-2.283.306-.682.673-1.3 1.118-1.716 1.364-1.277 3.8-2.892 5.205-3.767a4.724 4.724 0 0 1 1.176-.522L86 72.221l.248.97Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M62.314 70.34a.448.448 0 0 1 .664 0l.003.004c.352.377.895.957 1.41 1.637.511.677 1.022 1.486 1.283 2.324.18.578.523 1.434.831 2.202l.018.045c.145.361.281.7.382.965.052.138.098.263.13.365.017.051.032.102.044.15a.841.841 0 0 1 .028.2c0 .277-.21.502-.47.502a.483.483 0 0 1-.467-.45 7.18 7.18 0 0 0-.135-.389c-.097-.256-.23-.586-.377-.952l-.016-.04c-.302-.752-.663-1.653-.86-2.28-.207-.67-.636-1.368-1.122-2.01a19.633 19.633 0 0 0-1.346-1.562.527.527 0 0 1 0-.71Zm3.86 7.959ZM95.755 37.29 62.84 34.273l.08-1 32.917 3.016-.08 1.001Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m86.594 44.794.47-8.54.937.06-.47 8.54-.937-.06Zm-10.33-1.004.47-8.54.937.059-.47 8.54-.937-.06Zm-11.036-.975.47-8.54.937.058-.47 8.54-.937-.058Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m107.958 46.833-54.938-4.52.072-1.003 54.938 4.522-.072 1.001ZM19.174 15.278a.45.45 0 0 1 .655.119l13.72 20.65c.071.106.148.201.235.29a515.578 515.578 0 0 1 6.106 6.325 160.216 160.216 0 0 1 2.714 2.927c.364.406.675.762.914 1.05.229.276.418.52.513.69a.523.523 0 0 1-.16.69.453.453 0 0 1-.645-.173 4.922 4.922 0 0 0-.41-.54 37.71 37.71 0 0 0-.89-1.021 161.43 161.43 0 0 0-2.696-2.908 515.616 515.616 0 0 0-6.094-6.313 2.935 2.935 0 0 1-.352-.435l-13.72-20.65a.525.525 0 0 1 .11-.7ZM51.61 42.312 30.48 8.654l1.56-1.12 21.13 33.658-1.56 1.12Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m54.898-4.407-21.13 15.071-.521-.836 21.13-15.07.52.835ZM18.2 66.665l-31.07-11.318.302-.95 31.071 11.317-.302.951Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M25.255 52.898c.24.103.358.395.262.653a4.92 4.92 0 0 1-.212.442c-.102.197-.24.453-.408.762a222.67 222.67 0 0 1-1.366 2.456c-1.128 2.003-2.65 4.673-4.325 7.594A4359.906 4359.906 0 0 1 9.28 82.013a.452.452 0 0 1-.647.162.523.523 0 0 1-.151-.692c2.621-4.52 6.577-11.365 9.924-17.204a1287.24 1287.24 0 0 0 4.32-7.586c.563-1 1.026-1.832 1.36-2.444.167-.307.3-.556.398-.743a9.722 9.722 0 0 0 .16-.328c.097-.258.37-.383.611-.28Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m21.56 59.895-32.4-12.057.308-.949 32.4 12.057-.309.95Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
)
export default SvgComponent
